import { render } from "./ReceiptChargeRequest.vue?vue&type=template&id=67e707d6&ts=true"
import script from "./ReceiptChargeRequest.vue?vue&type=script&lang=ts"
export * from "./ReceiptChargeRequest.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__